module.exports = __webpack_public_path__ + "static/Objective-C-a2e3facdecb4a043db6e3e225c835145.svg";